import "./App.css";
import React, { useEffect, useState } from "react";
import UIRoutes from "./Routes/Routes";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const redirectToNewDomain = () => {
    window.location.href = "https://www.test.insyts.co/";
  };

  // useEffect(() => {
  //   // const token = 
  //   //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnRJZCI6IldBU1pTNFMiLCJ1c2VySWQiOiJhamF5QGdtYWlsLmNvbSIsInVzZXJOYW1lIjoiQWpheSAgcyIsImlhdCI6MTczNzY4ODIwMiwiZXhwIjoxNzM3NzE3MDAyfQ.qIkqsq_yeHSQf1iDndgP_4SjkE9ISngrano9u2fqRN4";
  //   const urlParams = new URLSearchParams(window.location.search);
  //   var token = urlParams.get("token");
  //   try {
  //     if (token) {
  //       window.localStorage.removeItem("token");
  //       window.localStorage.setItem("token", token);
  //       sessionStorage.setItem("tokenTimestamp", new Date().getTime().toString());
  //       setIsLoggedIn(true);
  //     }

  //     const isToken = window.localStorage.getItem("token");
  //     console.log("isToken-->", isToken);

  //     if (!isToken && token === null) {
  //       redirectToNewDomain();
  //     } else {
  //       setIsLoggedIn(true);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // }, []);

  return (
    <div className="App">
      <UIRoutes />
    </div>
  );
}

export default App;
